'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = CarCompany;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _emailStyleTools = require('helpers/emailStyleTools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CarCompany(props) {
  var company = props.company,
      components = props.components;


  var stylesCarCompanyContainer = (0, _emailStyleTools.containerStyles)(components, 'CarCompanyContainer');
  var stylesCarCompanyLabel = (0, _emailStyleTools.textStyles)(components, 'CarCompanyLabel');

  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'CarCompany' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, stylesCarCompanyContainer, _emailStyleTools.padTen) },
          _react2.default.createElement(
            'span',
            { style: stylesCarCompanyLabel },
            company
          )
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Car/Email/Active/CarCompany.jsx
// module id = 1495
// module chunks = 0